import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\ErrorLogController::index
* @see app/Http/Controllers/Admin/ErrorLogController.php:23
* @route '/admin/errors'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/admin/errors',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\ErrorLogController::index
* @see app/Http/Controllers/Admin/ErrorLogController.php:23
* @route '/admin/errors'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ErrorLogController::index
* @see app/Http/Controllers/Admin/ErrorLogController.php:23
* @route '/admin/errors'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ErrorLogController::index
* @see app/Http/Controllers/Admin/ErrorLogController.php:23
* @route '/admin/errors'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

const errors = {
    index: Object.assign(index, index),
}

export default errors